export default "__VITE_ASSET__DZk4fOD9__"